import { __awaiter, __generator } from "tslib";
import * as _cloneDeep from 'lodash/cloneDeep';
import * as _set from 'lodash/set';
import * as chatEventEmitter from '../../services/chat-event-emitter.service';
var HydrationHistoryValue;
(function (HydrationHistoryValue) {
    HydrationHistoryValue[HydrationHistoryValue["Hyderated"] = 1] = "Hyderated";
    HydrationHistoryValue[HydrationHistoryValue["OriginalActionResolved"] = 2] = "OriginalActionResolved";
})(HydrationHistoryValue || (HydrationHistoryValue = {}));
var hydrationHistory;
var stateToDbMiddleware = function () {
    hydrationHistory = new Map();
    return function () { return function (next) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!action.dbPayload || isActionHydrated(action.dbPayload)) {
                return [2 /*return*/, next(action)];
            }
            dispatchDBAction(action, next);
            setActionHydrated(action.dbPayload);
            return [2 /*return*/, next(action).then(function (data) {
                    setOriginalActionResolved(action.dbPayload);
                    return saveDataFromServerInDB(data, action.dbPayload);
                })];
        });
    }); }; }; };
};
var wrapDBLoadPromise = function (dbPayload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, dbPayload.load()
                .then(function (result) {
                if (isOriginalActionResolved(dbPayload)) {
                    return undefined;
                }
                else {
                    return result;
                }
            }).catch(function (error) {
                reportErrorToBI(error, 'loading from db');
            })];
    });
}); };
var reportErrorToBI = function (error, source) {
    console.warn("Error while state to db '" + source + "': " + error);
    chatEventEmitter.emit(chatEventEmitter.CHAT_EVENTS.BI_ERROR, {
        tag: 'db-storage',
        description: source,
        errorName: error
    });
};
var isActionHydrated = function (dbPayload) {
    var hydrated = dbPayload.hydrationKey && hydrationHistory.get(dbPayload.hydrationKey);
    return hydrated === HydrationHistoryValue.Hyderated || hydrated === HydrationHistoryValue.OriginalActionResolved;
};
var isOriginalActionResolved = function (dbPayload) {
    var hydrated = dbPayload.hydrationKey && hydrationHistory.get(dbPayload.hydrationKey);
    return hydrated === HydrationHistoryValue.OriginalActionResolved;
};
var setActionHydrated = function (dbPayload) {
    hydrationHistory.set(dbPayload.hydrationKey, HydrationHistoryValue.Hyderated);
};
var setOriginalActionResolved = function (dbPayload) {
    hydrationHistory.set(dbPayload.hydrationKey, HydrationHistoryValue.OriginalActionResolved);
};
var dispatchDBAction = function (action, next) {
    if (action === null || action === void 0 ? void 0 : action.dbPayload) {
        var dbStorageAction = _cloneDeep(action);
        dbStorageAction.payload = wrapDBLoadPromise(action.dbPayload);
        _set(dbStorageAction, 'meta.fromStorage', true);
        next(dbStorageAction);
    }
};
var saveDataFromServerInDB = function (data, dbPayload) {
    dbPayload.save(data).catch(function (reason) { return reportErrorToBI(reason, 'saving to db'); });
    return data;
};
export default stateToDbMiddleware;
